import { css } from '@emotion/react';
import { FunctionComponent } from 'react';

/**
 * Packages & Components
 */
import { FlexContainer } from '@astrumu/ui-library';

export const GoalsSkeleton: FunctionComponent<{ itemsCount?: number }> = ({
  itemsCount = 2
}) => (
  <FlexContainer as="ul" style={{ margin: '30px 0', justifyContent: 'center' }}>
    {[...Array(itemsCount)].map((_, index) => (
      <FlexContainer
        as="li"
        key={index}
        style={theme => ({
          margin: 2,
          gap: 3,
          height: 32,
          padding: '7px 12px',
          borderRadius: 15,
          background: theme.primaryBackgroundColor,
          border: `1px solid ${theme.contourColor}`,
          width: index % 2 === 0 ? 100 : 75
        })}
      >
        <span
          css={theme =>
            css({
              width: 45,
              height: 5,
              borderRadius: 3,
              display: 'block',
              margin: 'auto',
              background: theme.contourColor
            })
          }
        />
      </FlexContainer>
    ))}
  </FlexContainer>
);
